<template>
    <MainContent>
        <template v-slot:header v-if="abonado">
            <PageTitle title="Detalles del abonado"></PageTitle>
            <div>
                <OpcionesDropdownComponent class="mt-2" v-bind:options="[
                    { to: { name: 'back.abonados.editar', params: { abonado_id: abonado.id}}, label: 'Editar'},
                    ...abonado.esta_renovado ? [
                        { type: 'url', url: abonado.url_imprimir, label: 'Imprimir' },
                        { type: 'action', action:() => enviarAbono(), label: 'Enviar'},
                        { type: 'action', action:() => $modal.show('cambiar-asiento-' + abonado.id), label: 'Cambiar butaca'},
                        { to: { name: 'back.abonados.liberar.asiento', params: {lista_id: lista_id, abonado_id: abonado.id}}, label: 'Liberar asiento'},
                    ] : []
                ]"/>
            </div>
        </template>
        <template v-slot:content>
            <div v-if="!loading">
                <div class="row">
                    <template v-if="manager.lfp">
                        <div class="alert alert-info">
                            Para más información, por favor consulte SGA
                        </div>
                    </template>

                    <b-list-group class="container-fluid list-group-unbordered mb-3">
                        <div class="d-md-flex">
                            <DatosAbonado :abonado="abonado" :manager="manager" />
                            <DatosAbono :abonado="abonado" :manager="manager" @actualizar="getAbonado()" />
                        </div>
                    </b-list-group>

                    <div class="col-12" v-if="abonado.plazos.length > 0">
                        <hr>
                    </div>

                    <div class="col-12 mt-3" id="plazos" v-if="abonado.plazos.length > 0">
                        <Plazos style="padding-bottom: 0 !important;" class="pl-5 pr-5" :plazos="abonado.plazos" :data="abonado" :params="params" url_generar_enlace="back.abonados.plazos.enviar-url-compra" @pagar-plazo="pagarPlazo" @pagar-plazos="pagarPlazos" @descontar-plazo="descontar"/>
                    </div>

                    <div class="col-12">
                        <hr>
                    </div>

                    <template v-if="abonado.transacciones.length > 0">
                        <div class="col-12" id="transacciones">
                            <Transacciones :transacciones="abonado.transacciones" :params="params" :ruta="'back.abonados.transacciones.editar'" @actualizar="getAbonado()" />
                        </div>

                        <div class="col-12">
                            <hr>
                        </div>
                    </template>

                    <div class="col-12" id="eventos-asistidos">
                        <EventosAsistidos :eventos="abonado.eventos_asistidos" :temporada="abonado.temporada"/>
                    </div>

                    <div class="col-12">
                        <hr>
                    </div>

                    <div class="col-12" id="sanciones">
                        <Sanciones :sanciones="abonado.sanciones" :abonado="abonado" @actualizar="getAbonado()" />
                    </div>

                    <div class="col-12">
                        <hr>
                    </div>

                    <div class="col-12" id="impresiones">
                        <Impresos :abonado="abonado" @actualizar="getAbonado()"></Impresos>
                    </div>

                    <div class="col-12">
                        <hr>
                    </div>

                    <div class="col-12" id="butacas-liberadas">
                        <AsientosLiberados :abonado="abonado" :font_size="'28'" :text_align="'left'" :show_recuperar="true" @actualizar="getAbonado()"/>
                    </div>
                    
                    <div class="col-12">
                        <hr>
                    </div>

                    <div class="col-12" id="monedero">
                        <Monedero :abonado="abonado" @actualizar="getAbonado()"/>
                    </div>

                    <div class="col-12">
                        <hr>
                    </div>
                    
                    <div class="col-12" id="observaciones">
                        <div class="row ml-xl-4 mr-xl-4 m-0">
                            <div class="col-12">
                                <Observaciones :observaciones="abonado.observaciones" @actualizar="editarObservacion" />
                            </div>
                        </div>
                    </div>

                    <div class="col-12">
                        <hr>
                    </div>

                    <div class="col-12">
                        <div class="row ml-xl-4 m-0">
                            <div class="col-12">
                                <DatosLegalesShow :abonado="abonado" :font_size="'28'" :text_align="'left'" :title="true" @editar-datos-legales="editarDatosLegales" />
                            </div>
                        </div>
                    </div>

                    <div class="col-12">
                        <hr>
                    </div>

                    <div class="col-12 ml-xl-4 m-0">
                        <DocumentosSubidosComponent @actualizado="getAbonado" :data="abonado" :url="url_documentacion" :params="params" :ruta="'back.abonados.borrar.documento'" :title="true" @editarDocumento="editarDocumento"></DocumentosSubidosComponent>
                    </div>
                </div>
            </div>
        </template>
    </MainContent>
</template>

<script>
import MainContent from "@/components/backend/components/MainContent";
import OpcionesDropdownComponent from "@/components/backend/components/OpcionesDropdownComponent";
import PageTitle from '@/components/backend/components/PageTitleComponent';

import DatosAbonado from '@/components/backend/abonados/DatosAbonado.vue';
import DatosAbono from '@/components/backend/abonados/DatosAbono.vue';

import EventosAsistidos from '@/components/backend/abonados/EventosAsistidos.vue';
import Sanciones from '@/components/backend/abonados/Sanciones.vue';
import Transacciones from '@/components/backend/components/transacciones/Transacciones';
import Observaciones from '@/components/backend/components/Observaciones.vue';
import AsientosLiberados from '@/components/backend/abonados/AsientosLiberados.vue';
import DocumentosSubidosComponent from '@/components/backend/components/documentos/DocumentosSubidosComponent';
import Plazos from '@/components/backend/components/plazos/Plazos';
import Impresos from '@/components/backend/abonados/Impresos.vue';
import Monedero from '@/components/backend/abonados/Monedero.vue';
import DatosLegalesShow from '@/components/backend/abonados/DatosLegalesShow.vue';

export default {
    props: ['lista_id', 'abonado_id'],
    data() {
        return {
            abonado: null,
            params: {
                abonado_id: this.abonado_id,
                filters: {
                    lista_abonado_id: this.lista_id
                }
            },
            loading: true,
            url_documentacion: null
        }
    },
    created() {
        this.getAbonado();
    },
    computed: {
        configuracion() {
            return this.$store.getters.getConfig;
        },
        manager() {
            return this.$store.getters.getFooter;
        },
    },
    methods: {
        cerrarModal(modal, actualizar) {
            this.$modal.hide(modal);
            if(actualizar) {
                this.getAbonado();
            }
        },
        getAbonado() {
            this.loading = true;

            const params = this.params;

            this.$store.dispatch(this.config.getVuexAlias('back.abonados.show'), params).then(res => {
                this.abonado = res.data.data;
                this.url_documentacion = this.config.API_BASE + '/f/upload/documento?tid=' + this.configuracion.hash_teatro + '&abonado_id=' + this.abonado_id;
            }).finally(() => this.loading = false);
        },
        pagarPlazo(metodo_pago, plazo_id) {
            let parametros = this.params;

            parametros.plazo_id = plazo_id;
            parametros.filters = {
                tid: this.configuracion.hash_teatro,
                metodo_pago: metodo_pago
            }

            this.$store.dispatch(this.config.getVuexAlias('back.abonados.plazos.pagar'), parametros).then(res => {
                this.$toast.success(res.data.message);
                this.getAbonado();
                this.close();
            }).catch(error => {
                this.$toast.error(error.response.data.message);
            });
        },
        pagarPlazos(metodo_pago) {
            let parametros = this.params;

            parametros.filters = {
                tid: this.configuracion.hash_teatro,
                metodo_pago: metodo_pago
            }

            this.$store.dispatch(this.config.getVuexAlias('back.abonados.plazos.pagar-todos'), parametros).then(res => {
                this.$toast.success(res.data.message);
                this.getAbonado();
                this.close();
            }).catch(error => {
                this.$toast.error(error.response.data.message);
            });
        },
        editarObservacion(observacion) {
            this.abonado.filters = {};
            this.abonado.abonado_id = this.abonado.id;
            this.abonado.observaciones = observacion;

            this.$store.dispatch(this.config.getVuexAlias('back.abonados.editar'), this.abonado).then(() => {
                this.$toast.success('Observación editada correctamente.');
                this.getAbonado();
            }).catch(error => {
                this.$toast.error('Ha ocurrido un error.');
            });
        },
        editarDocumento(documento) {
            this.abonado.filters = {};
            this.abonado.abonado_id = this.abonado.id;
            this.abonado.documento_id = documento['id'];
            this.abonado.documento = documento;

            this.$store.dispatch(this.config.getVuexAlias('back.abonados.editar.documento'), this.abonado).then(() => {
                this.$toast.success('Documento editado correctamente.');
                this.getAbonado();
            }).catch(error => {
                this.$toast.error('Ha ocurrido un error.');
            });
        },
        editarDatosLegales() {
            this.abonado.filters = {};
            this.abonado.abonado_id = this.abonado.id;

            this.$store.dispatch(this.config.getVuexAlias('back.abonados.editar'), this.abonado).then(() => {
                this.$toast.success('Datos legales editados correctamente.');
                this.getAbonado();
            }).catch(error => {
                this.$toast.error('Ha ocurrido un error.');
            });
        },
        enviarAbono() {
            const params = this.params;

            this.$store.dispatch(this.config.getVuexAlias('back.abonados.abono.enviar'), params).then(res => {
                this.$toast.success("Abono enviado");
            });
        },
        descontar(descuento_integro, descuento_porcentaje, plazo_id) {
            let parametros = this.params;

            parametros.plazo_id = plazo_id;
            parametros.filters = {
                tid: this.configuracion.hash_teatro,
                descuento_integro: descuento_integro,
                descuento_porcentaje: descuento_porcentaje
            }

            this.$store.dispatch(this.config.getVuexAlias('back.abonados.plazos.descontar'), parametros).then(res => {
                this.$toast.success(res.data.message);
                this.getAbonado();
                this.cerrarModal('descuento-plazo-' + plazo_id, true);
            }).catch(e => {
                this.$toast.error('Error al intentar aplicar un descuento');
            });
        }
    },
    components: {
        OpcionesDropdownComponent,
        MainContent, PageTitle, EventosAsistidos, Sanciones, Transacciones, Observaciones,
        AsientosLiberados, DocumentosSubidosComponent, DatosAbonado, DatosAbono, Plazos, Impresos,
        Monedero, DatosLegalesShow
    }
}
</script>